<template>
  <div class="page-home">
    <el-row :gutter="16">
      <el-col :xs="24" :sm="12">
        <el-card shadow="never" class="stat-card">
          <div class="stat-label">证书档案</div>
          <div class="stat-value">{{ certTotal }}</div>
          <el-button type="text" @click="$router.push('/certificates')">去维护</el-button>
        </el-card>
      </el-col>
      <el-col :xs="24" :sm="12">
        <el-card shadow="never" class="stat-card">
          <div class="stat-label">累计查询次数</div>
          <div class="stat-value">{{ logTotal }}</div>
          <el-button type="text" @click="$router.push('/query-logs')">查看记录</el-button>
        </el-card>
      </el-col>
    </el-row>
    <el-card class="hint-card" shadow="never">
      <div class="hint-title">说明</div>
      <ul class="hint-list">
        <li>在「证书档案」中维护查询码与各展示字段；前台用户输入<strong>查询码</strong>即可拉取报告。</li>
        <li>每次前台查询会在「查询记录」中留痕（含时间与来源 IP，便于审计）。</li>
        <li>生产环境请修改默认管理员密码，并通过环境变量 <code>ACCA_JWT_SECRET</code> 配置足够长的 JWT 密钥。</li>
      </ul>
    </el-card>
  </div>
</template>

<script>
import { certPageApi } from '../api/certificate'
import { queryLogPageApi } from '../api/queryLog'

export default {
  name: 'AccaHome',
  data() {
    return {
      certTotal: '—',
      logTotal: '—'
    }
  },
  async mounted() {
    try {
      const [c, l] = await Promise.all([
        certPageApi({ page: 0, size: 1 }),
        queryLogPageApi({ page: 0, size: 1 })
      ])
      this.certTotal = (c.data && c.data.totalElements != null) ? c.data.totalElements : '—'
      this.logTotal = (l.data && l.data.totalElements != null) ? l.data.totalElements : '—'
    } catch (e) {
      /* ignore */
    }
  }
}
</script>

<style lang="scss" scoped>
.page-home {
  max-width: 960px;
}

.stat-card {
  margin-bottom: 16px;
}

.stat-label {
  font-size: 13px;
  color: #909399;
}

.stat-value {
  font-size: 28px;
  font-weight: 600;
  color: #303133;
  margin: 8px 0 4px;
}

.hint-card {
  margin-top: 8px;
}

.hint-title {
  font-weight: 600;
  margin-bottom: 8px;
}

.hint-list {
  margin: 0;
  padding-left: 18px;
  color: #606266;
  font-size: 13px;
  line-height: 1.8;

  code {
    font-size: 12px;
    background: #f4f4f5;
    padding: 1px 6px;
    border-radius: 4px;
  }
}
</style>
